export const HEADER_HEIGHT = 80;
export const HEADER_MENU_WIDTH = 700;
export const MOBILE_MENU_ACTIVATION_WIDTH = 1000;
export const MOBILE_MENU_WIDGETS_WIDTH = 765;
